<template>
    <div class="fertilization-time">
        <span v-b-tooltip.hover :title="$translate('time_since_fertilization')"
            >{{ hours }} {{ $translate('h_hour') }}</span
        >
        <icon139-hour v-if="show139HourIcon" />
    </div>
</template>

<script>
import { MAX_SUPPORTED_HOURS_FOR_EQ_SCORE, TREATMENT_STATUS } from '../../../business/const'
import Icon139Hour from './icons/Icon139Hour.vue'

export default {
    name: 'FertilizationTime',
    components: { Icon139Hour },
    props: {
        hours: {
            type: Number,
            required: true
        },
        status: {
            type: String,
            default: TREATMENT_STATUS.INACTIVE
        }
    },
    computed: {
        show139HourIcon() {
            return (
                this.status === TREATMENT_STATUS.IN_PROGRESS &&
                this.hours > MAX_SUPPORTED_HOURS_FOR_EQ_SCORE
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.fertilization-time {
    display: flex;
    align-items: center;
    font-size: 10pt;
    color: $light-3;
    white-space: nowrap;
    font-weight: var(--font-weight-bold);
}
</style>
